import React, { useState } from 'react';

const About = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  const images = [
    '/event1.jpg', // Replace with your actual image paths
    '/event2.jpg',
    '/event3.jpeg',
  ];

  return (
    <section id="about" className="py-16 md:py-24 bg-gradient-to-br from-gray-50 to-white">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center relative">
          
          {/* Vertical Line Between Columns */}
          <div className="hidden lg:block absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 w-0.5 bg-gray-400 h-3/4"></div>
          
          {/* Left Column - Images with Sticky Note */}
          <div className="relative flex flex-col items-center justify-center">
            {/* Sticky Note */}
            <div className="absolute -top-4 -left-6 z-20 transform -rotate-6">
              <div className="bg-orange-400 shadow-2xl p-4 w-36 h-36 flex flex-col items-center justify-center" style={{
                clipPath: 'polygon(0% 0%, 100% 0%, 100% 85%, 95% 100%, 0% 100%)',
                boxShadow: '4px 4px 10px rgba(0,0,0,0.3)'
              }}>
                <div className="text-center">
                  <p className="text-xl font-bold text-white mb-1" style={{ fontFamily: "'Diplomata', cursive" }}>
                    Know
                  </p>
                  <p className="text-2xl font-black text-white mb-1" style={{ fontFamily: "'Diplomata', cursive" }}>
                    US
                  </p>
                  <p className="text-lg font-bold text-white" style={{ fontFamily: "'Diplomata', cursive" }}>
                    Already
                  </p>
                </div>
                {/* Sticky note pin/tape effect */}
                <div className="absolute -top-2 left-1/2 transform -translate-x-1/2 w-10 h-5 bg-yellow-200 opacity-70 rounded-sm"></div>
              </div>
            </div>
            
            {/* Main Featured Image */}
            <div className="relative z-10 mt-20 w-full max-w-lg mx-auto">
              <img 
                src="/event-main.jpg" // Replace with your main event image
                alt="Event" 
                className="w-full h-96 object-cover rounded-lg shadow-2xl cursor-pointer hover:scale-105 transition-transform duration-300"
                onClick={() => setSelectedImage('/event-main.jpg')}
              />
            </div>

            {/* Small Image Grid */}
            <div className="grid grid-cols-3 gap-4 mt-6 w-full max-w-lg mx-auto">
              {images.map((img, index) => (
                <img 
                  key={index}
                  src={img}
                  alt={`Event ${index + 1}`}
                  className="w-full h-24 object-cover rounded-lg shadow-lg cursor-pointer hover:scale-110 transition-transform duration-300"
                  onClick={() => setSelectedImage(img)}
                />
              ))}
            </div>
          </div>

          {/* Right Column - Content */}
          <div className="flex items-center justify-center">
            <div className="space-y-8 max-w-xl px-8">
              <div className="inline-block">
                <h2 className="text-4xl md:text-5xl font-black text-gray-900 mb-3 text-left" style={{ fontFamily: "'Diplomata', 'Arbutus', cursive" }}>
                  We are Event Storytellers
                </h2>
                <div className="w-full h-1.5 bg-[#b8d4d4] mb-6"></div>
              </div>

              <div className="space-y-6">
                <p className="text-xl text-gray-700 leading-relaxed text-left" style={{ fontFamily: "'Hepta Slab', serif" }}>
                  We're passionate about creating unforgettable experiences. As people who truly love our craft, we bring energy and dedication to every project we undertake!
                </p>

                {/* <p className="text-xl text-gray-700 leading-relaxed text-left" style={{ fontFamily: "'Hepta Slab', serif" }}>
                  It's been 15 years of creating unique stories and experiences.<br />
                  We fall into a niche what you may call<br />
                  'People who love their jobs' and it shows in our work!
                </p> */}

                <p className="text-xl text-gray-700 leading-relaxed text-left" style={{ fontFamily: "'Hepta Slab', serif" }}>
                  Omnifairglobal is a one-stop destination for all your event requirements. We take care of your luxuries and ensure the necessities take care of themselves.
                </p>
              </div>
            </div>
          </div>

        </div>
      </div>

      {/* Lightbox Modal for Full Image View */}
      {selectedImage && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-90 z-50 flex items-center justify-center p-4"
          onClick={() => setSelectedImage(null)}
        >
          <div className="relative max-w-5xl w-full">
            <button 
              className="absolute top-4 right-4 text-white text-4xl hover:text-gray-300"
              onClick={() => setSelectedImage(null)}
            >
              ×
            </button>
            <img 
              src={selectedImage} 
              alt="Full view" 
              className="w-full h-auto max-h-screen object-contain rounded-lg"
            />
          </div>
        </div>
      )}
    </section>
  );
};

export default About;